module.exports = {"env":"production","apiUrl":"https://adminapivale.gbc.pe","apiValeUrlV2":"https://valeapi.gbc.pe"};